import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const dueToday = Loadable(() => (isFuncComp() ? import('../../containers/FunctionalRedesign/dueToday') : import('../../containers/web/dueToday')));

// const dueToday = Loadable(() => import('../../containers/web/dueToday'));
export default MapTo('vcg/components/soe-home/react/dueToday')(dueToday);
